import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  onChangeLanguage = new EventEmitter<any>();
  constructor() { }
}
